import { useRef, useState } from 'react'

import { DSAccordion, DSCol, DSRow, DSTag, DSText } from '@vr/ds-react'

import { CollectUnitsProps } from './interface'
import { CollectUnitsList } from '../collect-units-list'
import { CARD_STATUS } from '@/constants/card-status'
import { STATUS_LOGISTICS } from '@/constants/status-logistics'
import { useCollectContext } from '@/contexts/collect.context'

export const CollectUnits = ({ data }: CollectUnitsProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [openCount, setOpenCount] = useState(0)
  const contentRef = useRef<HTMLDivElement>(null)
  const { setCollect } = useCollectContext()

  const handleClick = () => {
    const willOpen = !isOpen
    setIsOpen(willOpen)
    if (willOpen) {
      setOpenCount(prev => prev + 1)
      setCollect(data)
    }
  }

  const variant = STATUS_LOGISTICS[data.situacao] ?? { style: 'outlined', label: '-' }

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick() }}
      role="button"
      tabIndex={0}
    >
      <DSAccordion
        defaultOpen={false}
        css={{
          marginTop: '16px',
          padding: '20px',
          border: '1px solid $ds-colors$neutralMedium',
          borderColor:
            data.situacao === 'recusado' && '$ds-colors$errorVeryDark',
          borderRadius: '8px'
        }}
      >
        <DSAccordion.Header>
          <DSRow wrap='wrap'>
            <DSCol
              xs={12}
              lg={4}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Operadora</DSText>
              <DSText as='strong' weight='bold'>
                {data.nomeOperadora}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Agrupamento</DSText>
              <DSText as='strong' weight='bold'>
                {data.codigo}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Qtde. CPFs</DSText>
              <DSText as='strong' weight='bold'>
                {String(data.quantidadeDeCPFs)}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Via dos cartões</DSText>
              <DSText as='strong' weight='bold'>
                {CARD_STATUS[data.segundaVia]}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Status da logística</DSText>
              <DSTag variant={variant.style}>{variant.label}</DSTag>
            </DSCol>
          </DSRow>
        </DSAccordion.Header>
        <DSAccordion.Content>
          <div
            ref={contentRef}
            role="presentation"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {isOpen && <CollectUnitsList key={openCount} collect={data} />}
          </div>
        </DSAccordion.Content>
      </DSAccordion>
    </div>
  )
}
